/* eslint-disable no-restricted-syntax */
class CustomImgTxtBlock extends HTMLElement {
  constructor() {
    super();
    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { height } = entry.contentRect;
        const { width } = entry.contentRect;
        entry.target.style.setProperty('--element-height', `${height}px`);
        entry.target.style.setProperty('--element-width', `${width}px`);
      }
    });
  }

  connectedCallback() {
    this.resizeObserver.observe(this);

    const rect = this.getBoundingClientRect();
    this.style.setProperty('--element-height', `${rect.height}px`);
    this.style.setProperty('--element-width', `${rect.width}px`);
  }

  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }
}

if (!customElements.get('custom-img-txt-block')) {
  customElements.define('custom-img-txt-block', CustomImgTxtBlock);
}
